import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Container } from '@mui/material';
import { PageHeader } from '../../../../components/common/header/PageHeader';
import { palette } from '../../../../../theme/palette';
import { useLocation } from 'react-router-dom';
import { SecondmentForm } from './secondment-form';
import { PermanentForm } from './permanent-form';
import { ContactForm } from './contact-form';
const theme = palette('light');
export const EditPlacement = () => {
    const location = useLocation();
    const [placement, setPlacement] = useState(null);
    useEffect(() => {
        try {
            const stateData = location.state;
            if (!stateData) {
                throw new Error('No placement data found in navigation state');
            }
            const processedData = {
                ...stateData
            };
            // const processedData: PlacementDto = {
            //     ...stateData,
            //     pp_StartDate: stateData.pp_StartDate ? new Date(stateData.pp_StartDate) : null,
            //     pp_BirthDate: stateData.pp_BirthDate ? new Date(stateData.pp_BirthDate) : null,
            //     pp_InvoiceDate: stateData.pp_InvoiceDate ? new Date(stateData.pp_InvoiceDate) : null,
            //     pp_GracePeriodStart: stateData.pp_GracePeriodStart ? new Date(stateData.pp_GracePeriodStart) : null,
            //     pp_GracePeriodEnd: stateData.pp_GracePeriodEnd ? new Date(stateData.pp_GracePeriodEnd) : null,
            //     pp_TrialPeriodStart: stateData.pp_TrialPeriodStart ? new Date(stateData.pp_TrialPeriodStart) : null,
            //     pp_TrialPeriodEnd: stateData.pp_TrialPeriodEnd ? new Date(stateData.pp_TrialPeriodEnd) : null
            // };
            setPlacement(processedData);
        }
        catch (err) {
        }
        finally {
        }
    }, [location.state]);
    if (!placement) {
        return _jsx("div", {});
    }
    return (_jsxs("div", { children: [_jsx(PageHeader, { goback: true, title: 'Edit Placement' }), _jsxs(Container, { maxWidth: 'lg', children: [placement.placementType === 'Permanent' && _jsx(PermanentForm, { row: placement }), placement.placementType === 'Contract' && _jsx(ContactForm, { row: placement }), placement.placementType === 'Secondment' && _jsx(SecondmentForm, { row: placement })] })] }));
};
